import React, { PropsWithChildren, useCallback, useState } from 'react';

import { AlertProps } from '@mui/material';

type AlertState = {
  message: string;
  open: boolean;
  severity?: AlertProps['severity'];
};

type AlertContextValue = {
  addAlert: (severity: AlertProps['severity'], message: string) => void;
  alert: AlertState;
  removeAlert: () => void;
};

export const AlertContext = React.createContext<AlertContextValue>({
  addAlert: (_severity: AlertProps['severity'], _message: string) => {},
  alert: { message: '', open: false },
  removeAlert: () => {},
});

export const AlertProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [alert, setAlert] = useState<AlertState>({
    message: '',
    open: false,
  });

  const addAlert = useCallback(
    (severity: AlertProps['severity'], message: string) => {
      setAlert({
        message,
        open: true,
        severity,
      });
    },
    []
  );

  const removeAlert = useCallback(() => {
    setAlert({
      message: '',
      open: false,
    });
  }, []);

  return (
    <AlertContext.Provider
      value={{
        addAlert,
        alert,
        removeAlert,
      }}
    >
      {children}
    </AlertContext.Provider>
  );
};
